module.exports = __webpack_public_path__ + "static/media/home-img1.ae99c8aa.jpg";